module.exports = __webpack_public_path__ + "img/sectors.4eabd050.svg";